import React from 'react';
import PopupServiceImg from 'Assets/layout/dashboard/popup-service.png';
import QuickButton from 'Douleutaras/components/QuickButton/QuickButton';
import DefaultModal from 'Douleutaras/components/modals/DefaultModal';
import { Trans } from 'react-i18next';
import Modal from 'Douleutaras/components/Modal/Modal';
import ModalSelectionItem from 'Douleutaras/components/modals/parts/ModalSelectionItem';
import { CCFModalOptions, CCFModalSlugs } from 'Douleutaras/types/index';
import { AllModalOptions, SolveIssueModalOptions } from 'Douleutaras/constants/ccf/need-help-options';
import { useHistory } from 'react-router-dom';

interface SolveIssuesModalProps {
  isOpen: boolean;
  options: CCFModalOptions;
  jobId?: string;
  jobCategoryId?: string;
  title: string | React.ReactElement;
  showBackButton?: boolean;
  userMugshot?: string;
  onBack?(): void;
  setIsOpen(modalStatus): void;
  onNoProSelected?(userSelection): void;
  onOptionSelected?(userSelection, saveReporting): void;
  saveReport?({ optionSlug }: { optionSlug: SolveIssueModalOptions }): void;
  onProContactSelected?({ extraBidConversationId, extraBidSellerPhoneNumber, extraBidSellerName, optionSlug }:
                          { extraBidConversationId: string,
                            extraBidSellerPhoneNumber: string,
                            extraBidSellerName: string,
                            extraBidSellerId: string,
                            optionSlug: AllModalOptions
                          }): void;
}

/**
 * This modal is used to display a list of Options to solve any potential client's issues
 */
export const SolveIssuesModal = ({
                                        isOpen,
                                        setIsOpen,
                                        options,
                                        onBack,
                                        onOptionSelected,
                                        saveReport,
                                        jobId,
                                        title,
                                        showBackButton,
                                        userMugshot
                                      }: SolveIssuesModalProps) => {

  return (
    <Modal isOpen={isOpen} dismissCallback={() => setIsOpen(false)}>
      <DefaultModal
        serviceIcon={PopupServiceImg}
        serviceIconAlt={<Trans>T.CCF.SELECT CONTACT MODAL.IMAGE ALT TEXT</Trans>}
        title={title}
        backText={<Trans>T.CCF.SELECT CONTACT MODAL.BACK BUTTON TEXT</Trans>}
        backTextAriaLabel={<Trans>T.CCF.SELECT CONTACT MODAL.BACK BUTTON TEXT</Trans>}
        closeAriaLabel={<Trans>T.CCF.SELECT CONTACT MODAL.CLOSE ICON LABEL</Trans>}
        closeButtonCallback={() => setIsOpen(false)}
        backButtonCallback={typeof onBack === 'function' ? onBack : () => false}
        showBackButton={showBackButton}
        userMugshot={userMugshot}
      >
        <div>
          { options?.[SolveIssueModalOptions.I_HAVE_AN_ISSUE]?.active &&
            <ModalSelectionItem>
              <QuickButton
                title={<Trans>T.CCF.SOLVE ISSUES MODAL.I HAVE AN ISSUE</Trans>}
                onClick={async () => {
                  if (typeof onOptionSelected === 'function') {
                    await onOptionSelected({
                      modalSlug: CCFModalSlugs.NEED_HELP,
                      optionSlug: SolveIssueModalOptions.I_HAVE_AN_ISSUE
                    }, true);
                  }
                }}
              />
            </ModalSelectionItem>
          }
          { options?.[SolveIssueModalOptions.I_WANT_TO_PROCEED_HAVE_PROCEEDED]?.active &&
            <ModalSelectionItem>
              <QuickButton
                title={<Trans>T.CCF.SOLVE ISSUES MODAL.EVERYTHING OK</Trans>}
                onClick={async () => {
                  await saveReport({ optionSlug: SolveIssueModalOptions.I_WANT_TO_PROCEED_HAVE_PROCEEDED });
                  window.location.href = `/dashboard/employer/jobs/${jobId}/status`;
                }}
              />
            </ModalSelectionItem>
          }
          {options?.[SolveIssueModalOptions.I_WONT_PROCEED_WITH_THE_JOB]?.active &&
            <ModalSelectionItem>
              <QuickButton
                title={<Trans>T.CCF.SOLVE ISSUES MODAL.WONT PROCEED</Trans>}
                onClick={async () => {
                  if (typeof onOptionSelected === 'function') {
                    await onOptionSelected({
                      modalSlug: CCFModalSlugs.CANCEL,
                      optionSlug: SolveIssueModalOptions.I_WONT_PROCEED_WITH_THE_JOB
                    }, true);
                  }
                }}
              />
            </ModalSelectionItem>
          }
        </div>
      </DefaultModal>
    </Modal>
  );
};

export default SolveIssuesModal;
